import { MenuOptionType } from "@dexteel/mesf-core";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { GridButtons } from "@/controls/buttons/GridButtons";
import { CatalogSection } from "@/shared/models/CatalogSection";
import { ColDef, ICellRendererParams } from "ag-grid-community";

type Props = {
	setSelectedRowData: (section: CatalogSection) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	showContextMenu: Function;
};

export const useTableData = ({
	setSelectedRowData,
	setShowModal,
	showContextMenu,
}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "SectionName",
			headerName: "Name",
			flex: 2,
			minWidth: 150,
		},
		{
			field: "-",
			cellRenderer: GridButtons,
			cellRendererParams: (params: ICellRendererParams) => ({
				setId: setSelectedRowData,
				id: params.data as CatalogSection,
				edit: true,
				setShowModal: setShowModal,
				showContextMenu: () =>
					showContextMenu(event, params.data, "sectionsContext"),
			}),
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			headerName: "",
			sortable: false,
			flex: 1,
			maxWidth: 220,
			filter: false,
			autoHeaderHeight: true,
		},
	];

	const getMenuOptions = (data: CatalogSection) => {
		let options: MenuOptionType[] = [];

		options = options.concat([
			{
				name: "New Section",
				key: "new_section",
				onClick: () => {
					setShowModal("create");
				},
				icon: <PlaylistAddIcon />,
			},
		]);

		if (data) {
			options = options.concat([
				{
					name: "Edit Section",
					key: "edit_section",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("update");
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Section",
					key: "delete_section",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("delete");
					},
					icon: <DeleteIcon />,
				},
			]);
		}

		return options;
	};

	return { columnDefs, getMenuOptions };
};
